<template>
  <div class="flex-between title">
    <v-title>{{ item.name }}</v-title>
    <div class="closeDraw" v-if="item.hasBtn">
      <el-button icon="el-icon-close" @click="handleClose"></el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    item: Object
  },
  computed: {
    ...mapGetters(["map"])
  },
  methods: {
    handleClose() {
      this.$store.dispatch("drawer/setRightComponent", "zzglRgihtDrawer");
    }
  }
};
</script>

<style lang="stylus" scoped>
.title
  position relative
  padding-bottom 0.025rem

  .titleName
    padding-left 8px
    color #00f0ff
    font-size 15px

  .btn
    padding 0
    background transparent
    border 0
    color #fff
    font-size 22px
    z-index 100

    &:hover
      background transparent
      color #fff

  .line
    position absolute
    width 290px
    height 2px
    background linear-gradient(to right, #00d3e2 30%, #006399 30%)
    bottom 0
.closeDraw
  position absolute
  right 10px
  top 20px
  .el-button
    background transparent
    color #fff
    font-size 25px
    padding 0
    border 0
    position relative
</style>
